import { LANG } from "@/lib/i18n";

const STRINGS = {
  en: {
    header: { cta: "Free Visibility Test" },
    hero: {
      badge: "Free AI Visibility Test",
      instant: "Instant score",
      noSignup: "No signup",
      whatsapp: "Report on WhatsApp",
    },
    trust: { title: "We scan your brand across every major AI answer engine" },
    domain: {
      placeholder: "Business name or website",
      button: "Show My AI Score",
      scanning: "Scanning…",
      error: "Enter your business name or website",
      hint: "No website? Your business name is enough.",
    },
    lead: {
      label: "Your WhatsApp number",
      placeholder: "555 123 4567",
      errorPhone: "Enter a valid WhatsApp number",
      errorGeneric: "Could not unlock report",
      success: "Full report unlocked & sent to WhatsApp",
      cta: "Send My Full Report",
    },
    lock: {
      locked: "Results locked",
      oneStep: "1 step to unlock",
      cta: "Unlock & Send to My WhatsApp",
    },
    how: { label: "Stupid simple. 3 steps.", title: "Run the test. See your score. Get the report." },
    why: { label: "Why this matters", live: "Live: a customer asking AI who to buy from" },
    demo: { badge: "#1 AI Recommended", answering: "Answering live", ask: "Ask anything…", reviews: "reviews" },
    flow: {
      label: "Built for every business",
      legendComp: "— — competitors",
      legendYou: "— your brand after fixes",
      score: "Your AI Visibility",
      marquee: "Whatever you do — your next customer is already asking AI about it",
    },
    results: {
      live: "Live Analysis",
      title: "AI Visibility Report",
      scanComplete: "Scan complete",
      cited: "Cited",
      notCited: "Not Cited",
      verdict: "The Verdict",
      sov: "Share of Voice",
      citation: "Citation Rate",
      presence: "Answer Presence",
      sentiment: "Brand Sentiment",
      chartPlatform: "Mentions by AI Platform",
      chartTrend: "Visibility Trend (6 mo.)",
      snippets: "Citation & Snippet Preview",
      bannerTitle: "Full report sent to your WhatsApp ✅",
      bannerSub: "The complete breakdown is unlocked below and on its way to your phone.",
      download: "Download PDF",
      weaknesses: "Competitive Weaknesses",
      opportunities: "Growth Opportunities",
      fixes: "Recommended AEO Fixes",
      benchmark: "Competitor Benchmark",
      you: "(You)",
      allSnippets: "All Snippet Citations",
      countries: "Visibility by Country",
      mentions: "mentions",
      score: "Score",
    },
    faq: { label: "Questions", title: "Frequently asked" },
    final: { label: "Your competitors aren't waiting", micro: "Free · No signup · Instant score" },
    footer: { line: "dev4u · AI Visibility Score Checker · Powered by AEO/SEO intelligence" },
    analyzer: {
      deep: "Deep scan in progress",
      across1: "analyzing across",
      across2: "6 AI platforms",
      scanning: "scanning…",
      answers: "answers",
      compare: "Live AI model comparison",
      kw: "Keywords analyzed",
      ans: "AI answers scanned",
      cit: "Citations found",
      footer: "Live scan across 6 AI answer engines",
    },
    gauge: { high: "High Visibility", medium: "Medium Visibility", low: "Low Visibility" },
    included: { cta: "Run My Free Test" },
    page: { analyzeError: "Could not analyze domain" },
  },
  he: {
    header: { cta: "בדיקת נראות AI בחינם" },
    hero: {
      badge: "בדיקת נראות AI — בחינם",
      instant: "ציון מיידי",
      noSignup: "בלי הרשמה",
      whatsapp: "הדוח אצלכם בוואטסאפ",
    },
    trust: { title: "סורקים את העסק שלכם בכל מנועי התשובות הגדולים" },
    domain: {
      placeholder: "שם העסק או כתובת האתר",
      button: "תראו לי את הציון",
      scanning: "סורקים…",
      error: "הזינו שם עסק או כתובת אתר",
      hint: "אין אתר? מספיק שם העסק — למשל: אופק ביטוחים חולון",
    },
    lead: {
      label: "מספר הוואטסאפ שלכם",
      placeholder: "050 123 4567",
      errorPhone: "הזינו מספר וואטסאפ תקין",
      errorGeneric: "לא הצלחנו לפתוח את הדוח",
      success: "הדוח המלא נפתח ונשלח לוואטסאפ ✅",
      cta: "שלחו לי את הדוח לוואטסאפ",
    },
    lock: {
      locked: "הדוח המלא נעול",
      oneStep: "צעד אחד ונפתח",
      cta: "שלחו לי את הדוח לוואטסאפ",
    },
    how: { label: "פשוט בטירוף. 3 שלבים.", title: "מריצים בדיקה. רואים ציון. מקבלים דוח." },
    why: { label: "למה זה חשוב לכם", live: "לקוח שואל עוזר AI מי מומלץ באזור שלו" },
    demo: { badge: "המלצת ה-AI מס' 1", answering: "עונה בשידור חי", ask: "שאלו כל דבר…", reviews: "ביקורות" },
    flow: {
      label: "מתאים לכל עסק",
      legendComp: "— — מתחרים",
      legendYou: "— העסק שלכם אחרי התיקונים",
      score: "נראות ה-AI שלכם",
      marquee: "מה שלא תעשו — הלקוח הבא שלכם כבר שואל על זה את ה-AI",
    },
    results: {
      live: "ניתוח בזמן אמת",
      title: "דוח נראות AI",
      scanComplete: "הסריקה הושלמה",
      cited: "מצוטט",
      notCited: "לא מצוטט",
      verdict: "השורה התחתונה",
      sov: "נתח שיח",
      citation: "שיעור ציטוט",
      presence: "נוכחות בתשובות",
      sentiment: "סנטימנט מותג",
      chartPlatform: "אזכורים לפי פלטפורמת AI",
      chartTrend: "מגמת נראות (6 חוד')",
      snippets: "תצוגה מקדימה של ציטוטים",
      bannerTitle: "הדוח המלא נשלח לוואטסאפ שלכם ✅",
      bannerSub: "הפירוט המלא נפתח למטה — ובדרך לטלפון שלכם.",
      download: "להורדת ה-PDF",
      weaknesses: "חולשות מול המתחרים",
      opportunities: "הזדמנויות צמיחה",
      fixes: "תיקוני AEO מומלצים",
      benchmark: "השוואה מול מתחרים",
      you: "(אתם)",
      allSnippets: "כל הציטוטים",
      countries: "נראות לפי מדינה",
      mentions: "אזכורים",
      score: "ציון",
    },
    faq: { label: "שאלות", title: "שאלות נפוצות" },
    final: { label: "המתחרים שלכם לא מחכים", micro: "חינם · בלי הרשמה · ציון מיידי" },
    footer: { line: "dev4u · בדיקת ציון נראות AI לעסקים" },
    analyzer: {
      deep: "סריקה עמוקה מתבצעת",
      across1: "מנתחים על פני",
      across2: "6 פלטפורמות AI",
      scanning: "סורקים…",
      answers: "תשובות",
      compare: "השוואת מודלים חיה",
      kw: "מילות חיפוש נותחו",
      ans: "תשובות AI נסרקו",
      cit: "ציטוטים נמצאו",
      footer: "סריקה חיה על פני 6 מנועי תשובות AI",
    },
    gauge: { high: "נראות גבוהה", medium: "נראות בינונית", low: "נראות נמוכה" },
    included: { cta: "להרצת הבדיקה החינמית" },
    page: { analyzeError: "לא הצלחנו לנתח את האתר" },
  },
};

const lookup = (dict, path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);

export const t = (key) => {
  const v = lookup(STRINGS[LANG], key);
  if (v !== undefined) return v;
  const fb = lookup(STRINGS.en, key);
  return fb !== undefined ? fb : key;
};
